module.exports = __webpack_public_path__ + "assets/img/1_1696_big.b89ff07d.jpg";